export enum RequestContentType {
  QUESTION = "question",
  TEST = "test",
  STUDY_MATERIAL = "study-material",
}
